<template>
    <div :data-overlay="navOverlayBanner">
        <component
            :is="bannerComponent"
            v-if="!hideBanner"
            :nav-overlay-banner="navOverlayBanner"
        >
            <template
                v-if="bannerDecoration"
                #bannerDecoration
            >
                <component :is="bannerDecoration" />
            </template>
        </component>
    </div>
</template>

<script setup>
    const { digistormSettings, appId, getGlobalSetField } = storeToRefs(useGlobalStore())
    const { entry } = storeToRefs(useEntryStore())

    const bannerComponents = import.meta.glob('./home/**/banner.async.vue')

    const primaryNavSettings = computed(() => {
        return first(getGlobalSetField.value('ds_Navigation_GlobalSet', 'primaryNav'))
    })

    const navOverlayBanner = computed(() => {
        if (hideBanner.value) {
            return false
        }

        return !primaryNavSettings.value?.primaryNav_ShowBackground
    })

    const bannerType = computed(() => {
        return digistormSettings.value.bannerType
    })

    const hideBanner = computed(() => {
        return get(entry.value, 'hideBanner', false)
    })

    // check for any custom headers
    const customComponents = await import(`~/custom/${appId.value}/index.js`).catch(() => {
        return null
    })

    const bannerDecoration = customComponents?.default?.HomeBannerDecoration

    const bannerComponent = computed(() => {
        if (bannerType.value === 'banner-custom') {
            return customComponents?.default?.HomeBanner
        }

        return defineAsyncComponent(() => {
            const banner = bannerComponents[`./home/${bannerType.value}/banner.async.vue`]
            return banner ? banner() : Promise.reject(new Error(`Unknown banner type: ${bannerType.value}`))
        })
    })
</script>
